function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-117.000000, -5822.000000)",
  stroke: "#5A5F65",
  strokeWidth: 0.9
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(113.000000, 5800.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M26.0894747,16 L12.260311,16 C8.24916202,16 5,19.2273534 5,23.2112723 L5,31.1093324 C5,34.611607 7.55784212,37.5654815 10.912659,38.183934 L10.9815351,42.2012994 C10.9815351,42.7163903 11.2921519,43.1965923 11.7769886,43.4031781 C11.9849654,43.5064641 12.1578438,43.54 12.3644515,43.54 C12.6750683,43.54 12.9519144,43.436714 13.1936481,43.265017 L19.6584364,38.3208314 L26.089689,38.3208314 C30.100838,38.3208314 33.35,35.093478 33.35,31.1095591 L33.35,23.2114989 C33.35,19.2274427 30.1006997,16 26.089689,16 L26.0894747,16 Z"
}))))));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "29px",
    viewBox: "0 0 30 29",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.04eb07a6.svg";
export { ForwardRef as ReactComponent };